<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import formatters from '@/mixins/formatters.js';

import PayoutListDetails from '@/modules/checkin-facility/pages/dashboard/visitor-payment/payout/arbitrage/payoutListDetails';
import PayoutEditFormModal from './payoutEditFormModal';
import PayoutForm from './payoutForm';

export default {
   name: "PayoutListModal",
   components: {
      DatePicker,
      PayoutListDetails,
      PayoutEditFormModal,
      PayoutForm
   },
   data() {
      return {
         facilityDetails: {},
         listOfPayoutData: {
            data: [],
            current_page: 1,
            per_page: 10,
            total: 10
         },
      }
   },
   methods: {
      async paginate(page) {
         var filter = {
            page: page,
            per_page: this.listOfPayoutData.per_page
         };
         // await this.getPayoutList({...filter,  page: page});
         await this.getPayoutList(filter);
      },

      // component form
      async editPayoutList(dataFromParent) {
         this.facilityDetails = dataFromParent;
         // this.form.facilityId = dataFromParent.id
         await this.getPayoutList({...this.filter});
         this.$bvModal.show('show-payout-list-modal')
      },
      async getPayoutList(filter) {
         this.listOfPayoutData = await this.$lionheart.get(`/v2/payout-list/${this.facilityDetails.id}`, { param: filter }).then((success) => success.data.data);
      },

      closeMainModal() {
         this.$bvModal.hide('show-payout-list-modal');
         this.$emit('closePayoutListModal');
      },

      showEmailConfirmationModal(data) {
         this.$bvModal.msgBoxConfirm(this.$t('admin_page.payout_modal.email_confirmation_text'), {
            title: this.$t('admin_page.payout_modal.email_confirmation_title'),
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            okTitle: this.$t('admin_page.payout_modal.send_email_text'),
            cancelTitle: this.$t('admin_page.payout_modal.cancel_email_text'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
         }).then(async (value) => {
            if(value) {
               await this.$lionheart.post('/v2/dg/send-payout-email', { payout_header_id: data.id}).then((success) => {
                  // show modal success
                  this.$bvModal.msgBoxOk(this.$t('admin_page.payout_modal.email_success_text'), {
                     size: 'md',
                     buttonSize: 'md',
                     okVariant: 'primary',
                     okTitle: this.$t('admin_page.payout_modal.email_success_sent_close_button'),
                     footerClass: 'p-2',
                     hideHeaderClose: false,
                     centered: true
                  });
               }).catch((error) => {
                  this.$bvToast.toast(this.$t('admin_page.payout_modal.email_failed_text'), {
                     // title: this.$t('admin_page.payout_modal.error_email_sending_title'),
                     variant: 'danger',
                     solid: true
                  });
               });
            }
         }).catch((err) => {
            console.log(err);
         });
      }
   },
   mixins: [formatters],
}
</script>

<template>
   <b-modal id="show-payout-list-modal" centered hide-footer no-close-on-backdrop size="xl" class="mb-4">
      <template #modal-header>
         <!-- title -->
         <div class="d-flex">
            <h5 class="mr-2 font-weight-bold text-primary">{{ $t('admin_page.payout_modal.payout_title') }}: </h5>
            <h5>" {{ facilityDetails.name }} "</h5>
         </div>
         <button type="button" class="close" @click="$bvModal.hide('show-payout-list-modal')">
            <span aria-hidden="true">&times;</span>
         </button>
      </template>
      <div class="container">
         <div class="row">

            <!-- Forms -->
             <div class="container">
                <div class="col-lg-12">

                  <!-- form -->
                  <PayoutForm :facilityId="facilityDetails.id" @reloadPayoutList="paginate(1)" @closePayoutListModal="closeMainModal"/>
                </div>
             </div>

            
            <!-- table -->
            <div class="col-12 mt-3" v-if="listOfPayoutData.data.length > 0 ">
               <div class="table-responsive table-bordered visitors-table">
                  <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
                     <thead>
                        <tr>
                           <th>{{ $t('admin_page.payout_modal.input_date_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.payout_date_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.amount_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.fee_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.processing_fee_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.vat_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.total_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.net_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.status_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.file_table_column') }}</th>
                           <th>{{ $t('admin_page.payout_modal.action_table_column') }}</th>
                        </tr>
                     </thead>

                     <tbody>
                        <tr v-for="(value, key) in listOfPayoutData.data">
                           <td>{{ formatDateToSlash(value.updated_at) }}</td>
                           <td>{{ formatDateToSlash(value.payout_date) }}</td>
                           <td>{{ formatNumber(value.amount) }}</td>
                           <td>{{ formatNumber(value.fee) }}</td>
                           <td>{{ formatNumber(value.processing_fee) }}</td>
                           <td>{{ formatNumber(value.vat) }}</td>
                           <td>{{ formatNumber(value.total) }}</td>
                           <td>{{ formatNumber(value.net) }}</td>
                           <td>{{ value.status == null || value.status == '' ? $t('admin_page.payout_modal.confirmed') : $t(`admin_page.payout_modal.${value.status}`) }}</td>
                           <td>
                              {{ $t('admin_page.payout_modal.uploaded_text') }}
                           </td>
                           <td>
                              <div class="d-flex">
                                 <a class="btn btn-primary btn-sm text-sm mr-4" role="button"
                                    @click="$refs.payoutEditFormModal.populateEditForm(value)">{{ $t('admin_page.payout_modal.edit_button') }}</a>
                                 <a class="btn btn-success btn-sm text-sm mr-4" role="button"
                                    @click="$refs.payoutListDetails.view(value, false)">{{ $t('admin_page.payout_modal.details_button') }}</a>
                                 <a class="btn btn-outline-dark btn-sm text-sm" role="button"
                                    @click="showEmailConfirmationModal(value)">{{ $t('admin_page.payout_modal.sent_email_button') }}</a>
                              </div>
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
               <div class="col-sm-8">
                  <pagination v-model="listOfPayoutData.current_page" :per-page="listOfPayoutData.per_page" :records="listOfPayoutData.total" @paginate="paginate"></pagination>
               </div>
            </div>

         </div>
      </div>
      <PayoutListDetails ref="payoutListDetails" />
      <PayoutEditFormModal ref="payoutEditFormModal" @reloadPayoutList="paginate(1)" />
   </b-modal>
</template>